import React from 'react';
import { Experiment, Variant } from '@marvelapp/react-ab-test';

import ProcessVersionA from './a';
import ProcessVersionB from './b';

export default props => (
    <Experiment name="paymentProcess">
        <Variant name="A">
            <ProcessVersionA {...props} />
        </Variant>
        <Variant name="B">
            <ProcessVersionB {...props} />
        </Variant>
    </Experiment>
);
